<div class="split-auth-container">
  <!-- Left Panel -->
  <div class="split-left-panel">
    <div class="split-left-bg">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="split-left-img">
      <div class="split-left-overlay"></div>
    </div>
    <div class="split-left-content">
      <span class="left-tagline">A Heritage of Love</span>
      <h1 class="left-title">Find Your Perfect Life Partner</h1>
      <p class="left-desc">
        Experience a matrimonial journey built on tradition, family values, and curated connections. Where heritage
        meets modern search capabilities.
      </p>

      <div class="trust-badge-list">
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">verified_user</span>
          <div class="badge-text">
            <h4>Verified Profiles</h4>
            <p>Every account goes through a thorough check for secure matchmaking</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">chat</span>
          <div class="badge-text">
            <h4>Secure Messaging</h4>
            <p>Your privacy and safety are always our top concern</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">shield</span>
          <div class="badge-text">
            <h4>Privacy Protected</h4>
            <p>Full control over your photos and profile visibility</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="split-right-panel">
    <!-- Mobile-only Banner -->
    <div class="mobile-onboarding-banner">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="mobile-banner-img">
      <div class="mobile-banner-overlay"></div>
      <div class="mobile-banner-text">
        <span class="left-tagline">A Heritage of Love</span>
        <h3>Find Your Perfect Partner</h3>
      </div>
    </div>

    <div class="onboarding-card">
      <div class="auth-header">
        <a routerLink="/" class="logo">Weddingly Matrimony</a>

        <!-- Progress Stepper -->
        <div class="step-progress-wrapper">
          <span class="progress-step-text">Step 2 of 4: Religion & Beliefs</span>
          <div class="stepper-bar">
            <div class="stepper-progress" style="width: 50%;"></div>
          </div>
        </div>

        <h2>Religion & Beliefs</h2>
        <p>Fill in your religious background and horoscope parameters</p>
      </div>

      <form [formGroup]="signupreligion" (ngSubmit)="onSubmit()" class="auth-form">

        <!-- Religion -->
        <div class="form-group">
          <label>Religion</label>

          <div class="input-with-icon search-dropdown custom-dropdown">

            <span class="material-symbols-outlined input-icon">
              church
            </span>

            <div class="warm-input selected-box" (click)="openDropdown('religion') ; $event.stopPropagation()">

              {{selectedReligionName || 'Select Religion'}}

              <span class="arrow">▼</span>

            </div>


            <div class="language-list" *ngIf="showReligionList">

              <input type="text" class="search-box" placeholder="Search here"
                (input)="searchDropdown($event,'religion')" (click)="$event.stopPropagation()">


              <div class="language-item" *ngFor="let rel of filteredReligions"
                (click)="selectDropdown(rel,'religion'); $event.stopPropagation()">

                {{rel.religion_nme}}

              </div>

            </div>

          </div>


          <span class="error-msg"
            *ngIf="signupreligion.get('religion')?.touched && signupreligion.get('religion')?.invalid">

            Religion selection is required

          </span>

        </div>

        <!-- Non-Religious Banner -->
        <div *ngIf="isNonReligious()" class="non-religious-banner" style="margin: 20px 0; padding: 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 1px solid #10b981; border-radius: 12px; box-shadow: 0 4px 12px rgba(16, 185, 129, 0.08);">
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 8px;">
            <span class="material-symbols-outlined" style="color: #059669; font-size: 26px;">public</span>
            <h4 style="margin: 0; color: #065f46; font-size: 16px; font-weight: 700;">Secular / Non-Religious Profile</h4>
          </div>
          <p style="margin: 0; color: #047857; font-size: 13.5px; line-height: 1.5;">
            As you selected <strong>{{ selectedReligionName }}</strong>, Caste, Sub-caste, Gothram, Rasi, Nakshatra, and Dosham fields are hidden and marked as <strong>Not Applicable</strong>. You won't be asked for caste or astrological requirements.
          </p>
        </div>

        <ng-container *ngIf="!isNonReligious()">
        <!-- Caste -->
        <div class="form-group">
          <label>Caste</label>

          <div class="input-with-icon search-dropdown">

            <span class="material-symbols-outlined input-icon">
              groups
            </span>


            <div class="warm-input selected-box" (click)="openDropdown('caste'); $event.stopPropagation()">

              {{selectedCasteName || 'Select Caste'}}

              <span class="arrow">▼</span>

            </div>


            <div class="language-list" *ngIf="showCasteList">


              <input type="text" class="search-box" placeholder="Search here" (input)="searchDropdown($event,'caste')"
                (click)="$event.stopPropagation()">



              <div class="language-item" *ngFor="let c of filteredCastes" (click)="selectDropdown(c,'caste')">

                {{c.caste_nme}}

              </div>


            </div>


          </div>


          <span class="error-msg" *ngIf="signupreligion.get('caste')?.touched && signupreligion.get('caste')?.invalid">

            Caste selection is required

          </span>

        </div>




        <!-- Sub Caste -->
        <div class="form-group">

          <label>Sub-Caste</label>


          <div class="input-with-icon search-dropdown">


            <span class="material-symbols-outlined input-icon">
              group
            </span>



            <div class="warm-input selected-box" (click)="openDropdown('subcaste'); $event.stopPropagation()">


              {{selectedSubCasteName || 'Select Sub-Caste'}}


              <span class="arrow">▼</span>


            </div>



            <div class="language-list" *ngIf="showSubCasteList">


              <input type="text" class="search-box" placeholder="Search here"
                (input)="searchDropdown($event,'subcaste')" (click)="$event.stopPropagation()">



              <div class="language-item" *ngFor="let sub of filteredSubcastes" (click)="selectDropdown(sub,'subcaste')">


                {{sub.subcaste_nme}}


              </div>


            </div>


          </div>



          <span class="error-msg"
            *ngIf="signupreligion.get('subcaste')?.touched && signupreligion.get('subcaste')?.invalid">

            Sub-caste selection is required

          </span>


        </div>




        <!-- Astrology Note -->
        <div class="astrology-note-container" style="margin: 24px 0 16px; padding: 14px 18px; background-color: #fcf8f2; border-left: 4px solid #C5A059; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
          <p style="margin: 0; font-size: 13px; color: #856404; font-style: italic; font-weight: 500; line-height: 1.5;">
            Astrology Details (Optional) – Fill these only if they are relevant to you or your family's preferences.
          </p>
        </div>

        <!-- Gothram -->
        <div class="form-group">

          <label>Gothram <span *ngIf="(selectedReligionName || '').toLowerCase() === 'hindu'" style="color: #dc3545;">*</span></label>


          <div class="input-with-icon search-dropdown">


            <span class="material-symbols-outlined input-icon">
              family_restroom
            </span>



            <div class="warm-input selected-box" (click)="openDropdown('gothram'); $event.stopPropagation()">


              {{selectedGothramName || 'Select Gothram'}}


              <span class="arrow">▼</span>


            </div>




            <div class="language-list" *ngIf="showGothramList">


              <input type="text" class="search-box" placeholder="Search here" (input)="searchDropdown($event,'gothram')"
                (click)="$event.stopPropagation()">



              <div class="language-item" *ngFor="let g of filteredGothrams" (click)="selectDropdown(g,'gothram')">


                {{g.gothram_nme}}


              </div>


            </div>


          </div>



          <span class="error-msg"
            *ngIf="signupreligion.get('gothram')?.touched && signupreligion.get('gothram')?.invalid">

            Gothram selection is required

          </span>


        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="star">Star / Nakshatra <span *ngIf="(selectedReligionName || '').toLowerCase() === 'hindu'" style="color: #dc3545;">*</span></label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">auto_awesome</span>
              <select id="star" formControlName="star" class="warm-input"
                [class.invalid]="signupreligion.get('star')?.touched && signupreligion.get('star')?.invalid">
                <option value="" disabled selected>Select Star</option>
                <option *ngFor="let s of natchras" [value]="s._id">{{ s.natchr_nme }}</option>
              </select>
            </div>
            <span class="error-msg" *ngIf="signupreligion.get('star')?.touched && signupreligion.get('star')?.invalid">
              Star selection is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="raasi">Raasi / Moon Sign <span *ngIf="(selectedReligionName || '').toLowerCase() === 'hindu'" style="color: #dc3545;">*</span></label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">dark_mode</span>
              <select id="raasi" formControlName="raasi" class="warm-input"
                [class.invalid]="signupreligion.get('raasi')?.touched && signupreligion.get('raasi')?.invalid">
                <option value="" disabled selected>Select Raasi</option>
                <option *ngFor="let r of rasis" [value]="r._id">{{ r.rasi_nme || r.rasi_name }}</option>
              </select>
            </div>
            <span class="error-msg"
              *ngIf="signupreligion.get('raasi')?.touched && signupreligion.get('raasi')?.invalid">
              Raasi selection is required
            </span>
          </div>
        </div>

        <div class="form-group">
          <label>Dosham Status <span *ngIf="(selectedReligionName || '').toLowerCase() === 'hindu'" style="color: #dc3545;">*</span></label>
          <div class="gender-radio-group">
            <label class="radio-label">
              <input type="radio" formControlName="dosham" value="No">
              <span>No</span>
            </label>
            <label class="radio-label">
              <input type="radio" formControlName="dosham" value="Yes">
              <span>Yes</span>
            </label>
            <label class="radio-label">
              <input type="radio" formControlName="dosham" value="Don't Know">
              <span>Don't Know</span>
            </label>
          </div>
          <span class="error-msg"
            *ngIf="signupreligion.get('dosham')?.touched && signupreligion.get('dosham')?.invalid">
            Dosham is required
          </span>
        </div>
        </ng-container>

        <button type="submit" class="gold-button submit-btn">
          <span>Continue</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>

        <div class="trust-note">
          <span class="material-symbols-outlined trust-lock">lock</span>
          <span>Your information is private and secure</span>
        </div>
      </form>
    </div>
  </div>
</div>